/**
 * @description: 公共接口
 */
export default {
  // 获取验证码
  getMessageCode: {
    url: '/mp/business/captchaNew',
    method: 'POST'
  },

  // 获取字典类型数据
  qryDictData: {
    url: '/mp/global/decorate/qryDictData/',
    method: 'GET'
  }
};
